import React from 'react';
import { Paper, Typography, Divider, Grid } from "@mui/material";

const ViewTestInstrument = ({ instrument }) => {
  if (!instrument) {
    return null;
  }

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Test Instrument Overview
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Machine ID: {instrument.machineId}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            Name: {instrument.name}
          </Typography>
        </Grid>
        {/* Add more fields as needed */}
      </Grid>
    </Paper>
  );
};

export default ViewTestInstrument;
